import React, { Component, Fragment } from "react";
import Time from "react-time-format";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import NumberFormat from "react-number-format";
import KurdishSoraniNumbersToWords from "kurdish-numbers-to-words/Sorani.js";
import n2wordsEN from "n2words/lib/i18n/AR.mjs";
export class PrintViewParadan extends Component {
 render() {
  const {
   change_Lang,
   view_paradan_obj,
   primary_logo_bill,
   footer_logo_bill,
   lang,
  } = this.props;
  let numberWordsSorani =
   view_paradan_obj.Amount !== ""
    ? KurdishSoraniNumbersToWords.convert(view_paradan_obj.Amount)
    : 0;
  let numWords1 =
   view_paradan_obj.Amount !== undefined && view_paradan_obj.Amount !== null
    ? n2wordsEN(
       parseFloat(view_paradan_obj.Amount.toString().replace(/,/g, ""))
      )
    : 0;
  return (
   <Fragment>
    <br />
    <br /> <br />
    <br />
    <br />
    <br /> <br />
    <br />
    <br />
    <div>
     <div class="row mt-1 fkr">
      <div class="col-3">
       <p
        style={{
         fontSize: "24px",
         color: "#000",
         textAlign: "right",
         fontWeight: "bold",
        }}
        class=" text-uppercase"
       >
        &nbsp;&nbsp;{change_Lang("date")} &nbsp;:&nbsp;
        <Time
         value={view_paradan_obj.createdAt}
         format="YYYY-MM-DD"
         style={{
          fontSize: "24px",
          color: "#000",
          fontWeight: "bold",
         }}
        />
       </p>
      </div>
      <div class="col-6 d-flex justify-content-center">
       <p
        style={{
         fontSize: "25px",
         color: "#000",
         fontWeight: "bolder",
        }}
        class={`d-flex justify-content-center text-uppercase ${
         lang !== "en" ? "fkr" : "fkp"
        } `}
       >
        {change_Lang("Payment bills")} ({change_Lang(view_paradan_obj.type)})
       </p>
      </div>
      <div class="col-3 text-right">
       <p
        style={{
         fontSize: "24px",
         color: "#000",
         fontWeight: "bold",
        }}
        class=" text-uppercase"
       >
        {change_Lang("in_invoice")}#&nbsp;
        {view_paradan_obj.invoice_No}&nbsp;
       </p>
      </div>
     </div>
     {/* first row */}
     <div
      class="row mt-1"
      style={{ width: "100%", backgroundColor: "#f4f4f6" }}
     >
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        وەرگر/المستلم :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fkr col-form-label d-flex justify-content-start"
        style={{
         fontSize: "22px",
         color: "#000",
        }}
       >
        {view_paradan_obj.payer}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkb"
       >
        : Receipt from
       </label>
      </div>
     </div>
     {/* second row */}
     <div class="row" style={{ width: "100%", backgroundColor: "white" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        بڕی پارە/مبلغ و قدره :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <NumberFormat
        displayType="text"
        thousandSeparator={true}
        value={view_paradan_obj.Amount}
        style={{
         fontSize: "22px",
         color: "#000",
        }}
        className="col-form-label"
        prefix={`${view_paradan_obj.currency === "dolar" ? "$" : "ID"}`}
       />
       &nbsp;&nbsp;
       <span
        className="fkr"
        style={{
         fontWeight: "bold",
         marginTop: "12px",
         color: "#000",
         fontSize: 18,
        }}
       >
        {" "}
        {lang === "krd" ? numberWordsSorani : numWords1}&nbsp;
        {`${
         view_paradan_obj.currency === "dolar"
          ? lang !== "krd"
            ? "دولار امریکي"
            : "دۆلاری ئەمریکی"
          : "دینار"
        }`}
        {change_Lang("Only")}
       </span>
      </div>
      <div class="col-3 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkb"
       >
        : Amount
       </label>
      </div>
     </div>
     {/* third row */}
     <div class="row" style={{ width: "100%", backgroundColor: "#f4f4f6" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        لە بڕی / وذلك عن :
       </label>
      </div>
      <div class="col-8 d-flex justify-content-center">
       {view_paradan_obj.type !== "investor" &&
       view_paradan_obj.instead_of === "" ? (
        <>
         <span
          className="fkr d-flex justify-content-center  mt-2"
          style={{
           fontSize: "17px",
           color: "#000",
           textAlign: "justify",
          }}
         >
          {view_paradan_obj.type !== "Monthly rent invoice" ? (
           <>
            {change_Lang(view_paradan_obj.type)} (
            {change_Lang(view_paradan_obj.property)})&nbsp;
            {change_Lang("from")}
            &nbsp;({view_paradan_obj.place}) &nbsp;
            {change_Lang("Number")}&nbsp;({view_paradan_obj.num})
           </>
          ) : (
           <>
            {change_Lang(view_paradan_obj.type)} (
            {change_Lang(view_paradan_obj.property)})&nbsp;
            {change_Lang("from")}
            &nbsp;({view_paradan_obj.place}) &nbsp;
            {change_Lang("Number")}&nbsp;({view_paradan_obj.num}
            )&nbsp;
            {change_Lang("from")}
            <br />
            {view_paradan_obj.from}
            &nbsp;
            {change_Lang("to")}&nbsp;
            {view_paradan_obj.to}
           </>
          )}
         </span>
        </>
       ) : (
        <span
         className="fkr d-flex justify-content-center mt-2"
         style={{
          fontSize: "17px",
          color: "#000",
          textAlign: "justify",
         }}
        >
         {view_paradan_obj && view_paradan_obj.instead_of}
        </span>
       )}
      </div>
      <div class="col-1 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkb"
       >
        : For
       </label>
      </div>
     </div>
     {/* five row */}
     <div class="row" style={{ width: "100%", backgroundColor: "white" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        پارەدەر / الدافع :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fkr col-form-label"
        style={{
         fontSize: "22px",
         color: "#000",
        }}
       >
        {view_paradan_obj.reciver}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label"
       >
        : Receptor
       </label>
      </div>
     </div>
     {/* note */}
     <div class="row" style={{ width: "100%", backgroundColor: "#f4f4f6" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        تێبینی / الملاحظات :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fkr col-form-label"
        style={{
         fontSize: "20px",
         color: "#000",
        }}
       >
        {view_paradan_obj.note}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label"
       >
        : Note
       </label>
      </div>
     </div>
     {/* six row */}
     <br /> <br />
     <br />
     <br />
     <div class="row">
      <div class="col-6 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
         fontWeight: "bold",
        }}
        class=" col-form-label fkr"
       >
        ({lang === "krd" ? "پارەدەر" : "الدافع"})&nbsp;واژوو / توقيع
       </label>
      </div>
      <div class="col-6 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
         fontWeight: "bold",
        }}
        class=" col-form-label fkr"
       >
        ({lang === "krd" ? "پارەوەرگر" : "المستلم"})&nbsp;واژوو / توقيع
       </label>
      </div>
      <div class="col-6 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        {view_paradan_obj.reciver}
       </label>
      </div>
      <div class="col-6 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        {view_paradan_obj.payer}
       </label>
      </div>
     </div>
    </div>
    <br />
    <br />
    {/* Second Invoice one*/}
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <div>
     <div class="row mt-1 fkr">
      <div class="col-3">
       <p
        style={{
         fontSize: "24px",
         color: "#000",
         textAlign: "right",
         fontWeight: "bold",
        }}
        class=" text-uppercase"
       >
        &nbsp;&nbsp;{change_Lang("date")} &nbsp;:&nbsp;
        <Time
         value={view_paradan_obj.createdAt}
         format="YYYY-MM-DD"
         style={{
          fontSize: "24px",
          color: "#000",
          fontWeight: "bold",
         }}
        />
       </p>
      </div>
      <div class="col-6 d-flex justify-content-center">
       <p
        style={{
         fontSize: "26px",
         color: "#000",
         fontWeight: "bolder",
        }}
        class={`d-flex justify-content-center text-uppercase ${
         lang !== "en" ? "fkr" : "fkp"
        } `}
       >
        {change_Lang("Payment bills")} ({change_Lang(view_paradan_obj.type)})
       </p>
      </div>
      <div class="col-3 text-right">
       <p
        style={{
         fontSize: "24px",
         color: "#000",
         fontWeight: "bold",
        }}
        class=" text-uppercase"
       >
        {change_Lang("in_invoice")}#&nbsp;
        {view_paradan_obj.invoice_No}&nbsp;
       </p>
      </div>
     </div>
     {/* first row */}
     <div
      class="row mt-1"
      style={{ width: "100%", backgroundColor: "#f4f4f6" }}
     >
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        وەرگر/المستلم :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fkr col-form-label d-flex justify-content-start"
        style={{
         fontSize: "22px",
         color: "#000",
        }}
       >
        {view_paradan_obj.payer}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkb"
       >
        : Receipt from
       </label>
      </div>
     </div>
     {/* second row */}
     <div class="row" style={{ width: "100%", backgroundColor: "white" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        بڕی پارە/مبلغ و قدره :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <NumberFormat
        displayType="text"
        thousandSeparator={true}
        value={view_paradan_obj.Amount}
        style={{
         fontSize: "22px",
         color: "#000",
        }}
        className="col-form-label"
        prefix={`${view_paradan_obj.currency === "dolar" ? "$" : "ID"}`}
       />
       &nbsp;&nbsp;
       <span
        className="fkr"
        style={{
         fontWeight: "bold",
         marginTop: "12px",
         color: "#000",
         fontSize: 18,
        }}
       >
        {" "}
        {lang === "krd" ? numberWordsSorani : numWords1}&nbsp;
        {`${
         view_paradan_obj.currency === "dolar"
          ? lang !== "krd"
            ? "دولار امریکي"
            : "دۆلاری ئەمریکی"
          : "دینار"
        }`}
        {change_Lang("Only")}
       </span>
      </div>
      <div class="col-3 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkb"
       >
        : Amount
       </label>
      </div>
     </div>
     {/* third row */}
     <div class="row" style={{ width: "100%", backgroundColor: "#f4f4f6" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        لە بڕی / وذلك عن :
       </label>
      </div>
      <div class="col-8 d-flex justify-content-center">
       {view_paradan_obj.type !== "investor" &&
       view_paradan_obj.instead_of === "" ? (
        <>
         <span
          className="fkr d-flex justify-content-center  mt-2"
          style={{
           fontSize: "17px",
           color: "#000",
           textAlign: "justify",
          }}
         >
          {view_paradan_obj.type !== "Monthly rent invoice" ? (
           <>
            {change_Lang(view_paradan_obj.type)} (
            {change_Lang(view_paradan_obj.property)})&nbsp;
            {change_Lang("from")}
            &nbsp;({view_paradan_obj.place}) &nbsp;
            {change_Lang("Number")}&nbsp;({view_paradan_obj.num})
           </>
          ) : (
           <>
            {change_Lang(view_paradan_obj.type)} (
            {change_Lang(view_paradan_obj.property)})&nbsp;
            {change_Lang("from")}
            &nbsp;({view_paradan_obj.place}) &nbsp;
            {change_Lang("Number")}&nbsp;({view_paradan_obj.num}
            )&nbsp;
            {change_Lang("from")}
            <br />
            {view_paradan_obj.from}
            &nbsp;
            {change_Lang("to")}&nbsp;
            {view_paradan_obj.to}
           </>
          )}
         </span>
        </>
       ) : (
        <span
         className="fkr d-flex justify-content-center mt-2"
         style={{
          fontSize: "17px",
          color: "#000",
          textAlign: "justify",
         }}
        >
         {view_paradan_obj && view_paradan_obj.instead_of}
        </span>
       )}
      </div>
      <div class="col-1 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkb"
       >
        : For
       </label>
      </div>
     </div>
     {/* five row */}
     <div class="row" style={{ width: "100%", backgroundColor: "white" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        پارەدەر / الدافع :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fkr col-form-label"
        style={{
         fontSize: "22px",
         color: "#000",
        }}
       >
        {view_paradan_obj.reciver}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label"
       >
        : Receptor
       </label>
      </div>
     </div>
     {/* note */}
     <div class="row" style={{ width: "100%", backgroundColor: "#f4f4f6" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        تێبینی / الملاحظات :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fkr col-form-label"
        style={{
         fontSize: "20px",
         color: "#000",
        }}
       >
        {view_paradan_obj.note}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "21px",
         color: "#000",
        }}
        class=" col-form-label"
       >
        : Note
       </label>
      </div>
     </div>
     {/* six row */}
     <div
      class="row"
      style={{ width: "100%", position: "absolute", bottom: 5 }}
     >
      <div class="col-6 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
         fontWeight: "bold",
        }}
        class=" col-form-label fkr"
       >
        ({lang === "krd" ? "پارەدەر" : "الدافع"})&nbsp;واژوو / توقيع
       </label>
      </div>
      <div class="col-6 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "#000",
         fontWeight: "bold",
        }}
        class=" col-form-label fkr"
       >
        ({lang === "krd" ? "پارەوەرگر" : "المستلم"})&nbsp;واژوو / توقيع
       </label>
      </div>
      <div class="col-6 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        {view_paradan_obj.reciver}
       </label>
      </div>
      <div class="col-6 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "#000",
        }}
        class=" col-form-label fkr"
       >
        {view_paradan_obj.payer}
       </label>
      </div>
     </div>
    </div>
   </Fragment>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  view_paradan_obj: state.Invoice_Reducer.view_paradan_obj,
  index_Paradan: state.Invoice_Reducer.index_Paradan,
  user: state.AuthReducer.user,
  primary_logo_bill: state.HelperReducer.primary_logo_bill,
  footer_logo_bill: state.HelperReducer.footer_logo_bill,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
 };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrintViewParadan);
